import { Component } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { Supplier } from "../supplier";
import { SupplierService } from "../supplier.service";

@Component({
  styleUrls: ['./supplier-details.component.css'],
  templateUrl: './supplier-details.component.html'
})
export class SupplierDetailsComponent {
  public query = "";
  private supplierId!: string | null;
  public supplier!: Supplier;

  constructor(
    private supplierService: SupplierService,
    private router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.paramMap.pipe(
      switchMap(paramMap => this.getSupplierIdFromParams(paramMap)),
      switchMap(supplierId => this.refreshSupplier(supplierId))
    ).subscribe();
  }

  private getSupplierIdFromParams(paramMap: ParamMap): Observable<string> {
    this.supplierId = paramMap.get("supplier");
    if (this.supplierId == null) {
      this.router.navigateByUrl("/404");

      return EMPTY;
    }

    return of(this.supplierId);
  }

  private refreshSupplier(supplierId: string): Observable<Supplier> {
    return this.supplierService.findById(supplierId)

      .pipe(tap(supplier => this.supplier = supplier));
  }
}